// extracted by mini-css-extract-plugin
export var social = "ContactSocial-module--social--3saqm";
export var button = "ContactSocial-module--button--OSzet";
export var button__label = "ContactSocial-module--button__label--McDI-";
export var button__hover = "ContactSocial-module--button__hover--3uBfW";